import {
  VehicleType,
  VehiclePointsMap,
  GapPosition,
} from './VehicleGapDetection.types';

/**
 * Mapowanie pozycji punktów kontrolnych dla różnych typów pojazdów
 * Współrzędne w procentach względem SVG viewBox
 *
 * Sedan:
 * - Widok lewy: A, B, C
 * - Widok górny: D, E (klapa bagażnika), I, J (pokrywa silnika)
 * - Widok prawy: F, G, H (od dołu)
 *
 * Hatchback:
 * - Widok lewy: A, B
 * - Widok górny: C, D (tył), G, H (przód)
 * - Widok prawy: E, F
 *
 * Van:
 * - Widok lewy: A, B
 * - Widok górny: C, D (tył), I, H (przód)
 * - Widok prawy: E, F, G
 */

const sedanPointsMap: VehiclePointsMap = {
  left: {
    A: { x: 40, y: 31 }, // Przód góra
    B: { x: 40, y: 52 },
    C: { x: 40, y: 70 }, // Przód dół
    D: undefined,
    E: undefined,
    F: undefined,
    G: undefined,
    H: undefined,
    I: undefined,
    J: undefined,
  },
  top: {
    A: undefined,
    B: undefined,
    C: undefined,
    D: { x: 23, y: 82 }, // Klapa bagażnika lewy
    E: { x: 77, y: 82 }, // Klapa bagażnika prawy
    F: undefined,
    G: undefined,
    H: undefined,
    J: { x: 19, y: 15 }, // Pokrywa silnika lewy
    I: { x: 81, y: 15 }, // Pokrywa silnika prawy
  },
  right: {
    A: undefined,
    B: undefined,
    C: undefined,
    D: undefined,
    E: undefined,
    F: { x: 60, y: 70 }, // Drzwi tylne prawe (dół)
    G: { x: 60, y: 52 }, // Środek prawy
    H: { x: 60, y: 31 }, // Góra prawy
    I: undefined,
    J: undefined,
  },
};

const vanPointsMap: VehiclePointsMap = {
  left: {
    A: { x: 40, y: 28 },
    B: { x: 40, y: 48 },
    C: undefined,
    D: undefined,
    E: undefined,
    F: undefined,
    G: undefined,
    H: undefined,
    I: undefined,
    J: undefined,
  },
  top: {
    A: undefined,
    B: undefined,
    I: { x: 13, y: 15 },
    H: { x: 87, y: 15 },
    C: { x: 23, y: 92 },
    D: { x: 77, y: 92 },
    G: undefined,
    F: undefined,
    E: undefined,
    J: undefined,

  },
  right: {
    A: undefined,
    B: undefined,
    C: undefined,
    D: undefined,
    H: undefined,
    F: { x: 60, y: 48 },
    G: { x: 60, y: 28 },
    I: undefined,
    E: { x: 60, y: 68 },
    J: undefined,
  },
};

const hatchbackPointsMap: VehiclePointsMap = {
  left: {
    A: { x: 44, y: 32 },
    B: { x: 44, y: 63 },
    C: undefined,
    D: undefined,
    E: undefined,
    F: undefined,
    G: undefined,
    H: undefined,
    I: undefined,
    J: undefined,
  },
  top: {
    A: undefined,
    B: undefined,
    H: { x: 17, y: 18 },
    G: { x: 83, y: 18 },
    C: { x: 23, y: 88 },
    D: { x: 77, y: 88 },
    E: undefined,
    F: undefined,
    I: undefined,
    J: undefined,
  },
  right: {
    A: undefined,
    B: undefined,
    C: undefined,
    D: undefined,
    F: { x: 53, y: 32 },
    E: { x: 53, y: 63 },
    G: undefined,
    H: undefined,
    I: undefined,
    J: undefined,
  },
};

/**
 * Pobiera mapowanie punktów dla danego typu pojazdu
 */
export const getVehiclePointsMap = (
  vehicleType: VehicleType,
): VehiclePointsMap => {
  const maps: Record<VehicleType, VehiclePointsMap> = {
    sedan: sedanPointsMap,
    van: vanPointsMap,
    hatchback: hatchbackPointsMap,
  };

  return maps[vehicleType];
};

/**
 * Pobiera współrzędne konkretnego punktu
 */
export const getPointCoordinates = (
  vehicleType: VehicleType,
  view: 'left' | 'top' | 'right',
  position: GapPosition,
) => {
  const map = getVehiclePointsMap(vehicleType);
  return map[view][position];
};
